import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanScheduledRepository } from "../../repositories/scheduler.repository";
import { ExceptionDates } from "../../domain/models/scheduler/exception-dates";

@Injectable({ providedIn: 'root' })
export class RemoveSchedulerInstanceUseCase implements UseCase<any, ExceptionDates> {

  constructor(private readonly planScheduledRepository: PlanScheduledRepository) {
  }

  execute(request:any): Observable<ExceptionDates> {
    return this.planScheduledRepository.removeSchedulerInstance(request);
  }

}